/**
 * QueryBuilder Store - session slice.
 *
 * Project binding (projectId), the one-shot v1-migration flag, and the
 * in-memory (never persisted) run results: single-run + batch-run.
 */
import { StateCreator } from "zustand"
import { QueryBuilderStore, SessionSlice } from "../types"
import { blankBuilder, blankPipeline } from "../helpers"

export const createSessionSlice: StateCreator<
  QueryBuilderStore,
  [["zustand/persist", unknown]],
  [],
  SessionSlice
> = (set) => ({
  projectId: null,
  migratedV1: false,
  lastRunBuilderId: null,
  lastRunResult: null,
  batchRunResult: null,
  batchRunBuilderIds: [],

  syncToProject: (projectId) =>
    set((state) => {
      if (state.projectId === projectId && state.builders.length > 0) {
        return state
      }
      // Cross-slice write: deliberately resets builder + pipeline slice
      // state too — slices share one store state.
      // Fresh project gets a single empty "Default" pipeline plus one
      // Builder pre-bound to it. Users can add more pipelines later.
      const defaultPipeline = blankPipeline("Default")
      const fresh = blankBuilder("Builder 1", defaultPipeline.id)
      return {
        projectId,
        builders: [fresh],
        activeBuilderId: fresh.id,
        transformPipelines: [defaultPipeline],
        activeTransformPipelineId: defaultPipeline.id,
        pipelineSavedNames: {},
        builderSavedNames: {},
        migratedV1: false,
        lastRunBuilderId: null,
        lastRunResult: null,
        batchRunResult: null,
        batchRunBuilderIds: [],
      }
    }),

  markMigrated: () => set({ migratedV1: true }),

  setBuilderResult: (id, result) =>
    set({ lastRunBuilderId: id, lastRunResult: result }),
  clearLastResult: () =>
    set({ lastRunBuilderId: null, lastRunResult: null }),

  setBatchResult: (result, builderIds) =>
    set({ batchRunResult: result, batchRunBuilderIds: builderIds }),
  clearBatchResult: () =>
    set({ batchRunResult: null, batchRunBuilderIds: [] }),
})
